
import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  components: {},
})
export default class ManagerSettingsEditorSubmenu extends Vue {
  @Prop({ type: Array, required: true }) readonly links!: { href: string, text: string, icon: string }[]
}
